function langSwitcher() {
    const currentLang = document.documentElement.lang;
    const langSwitcher = document.querySelector(".lang-switcher");
    if (!langSwitcher) return;

    const langToggle = langSwitcher.querySelector(".lang-toggle");
    const langLinks = langSwitcher.querySelectorAll("a[data-lang]");

    langToggle.textContent = currentLang;

    langToggle.addEventListener("click", () => {
        langSwitcher.classList.toggle("active");
    });

    langLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
            langToggle.textContent = link.dataset.lang;
            langSwitcher.classList.remove("active");
        });
    });

    document.body.addEventListener("click", function (e) {
        if (!langSwitcher.contains(e.target)) {
            langSwitcher.classList.remove("active");
        }
    });

    function countMargin() {
        let header = document.querySelector("header");
        if (header) {
            let menuAction = header.querySelector(".menu-action");
            let countMargin;
            if (window.matchMedia("(min-width: 951px").matches) {
                countMargin = menuAction.getBoundingClientRect().width + 40;
            } else {
                countMargin = 0;
            }

            langSwitcher.style.right = `${countMargin}px`;
        }
    }

    countMargin();

    window.addEventListener("resize", function () {
        countMargin();
    });
}

langSwitcher();
